import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientRegisteredVendor } from 'src/app/classes/models';

@Component({
  selector: 'app-confirm-run-business-verification-modal',
  templateUrl: './confirm-run-business-verification-modal.component.html',
  styleUrls: ['./confirm-run-business-verification-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmRunBusinessVerificationModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  @Input() ClientRegisteredVendor!: ClientRegisteredVendor;

  continue() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.dismiss(false);
  }
}
